"use client";

import { AnimatePresence, motion } from "motion/react";

import { defaultTransitionDuration } from "../../../../constants";
import type { TableRowType } from "../../Table.types";
import { TableExpansionMobileProps } from "./Table.types.mobile";
import { TableGroupMobile } from "./TableGroup.mobile";

export const TableExpansionMobile = <
  Row extends TableRowType,
  Group extends string = never,
>(
  props: TableExpansionMobileProps<Row, Group>,
) => {
  const { isOpen, columnGroups, ...rest } = props;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          exit={{ height: 0 }}
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          transition={{ duration: defaultTransitionDuration }}
          className="ui:overflow-hidden ui:border-t ui:border-divider"
        >
          {columnGroups.map((group) => (
            <TableGroupMobile<Row, Group>
              {...rest}
              group={group}
              key={group.start}
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
